/** Documentation link for the web client. */
export const DOCS_URL = "https://system-bridge.timmo.dev/using/web-client";
